import Text14 from '@sdk/components/ui/typography/Text14';
import dateToMonth from '@sdk/utils/dateFormat/dateToMonth';
import getTwoDigitDay from '@sdk/utils/dateFormat/getTwoDigitDay';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

const DateRowReadOnly = ({ date }: { date: Date }) => {
  const dateString = `${dateToMonth(date, true)} ${getTwoDigitDay(date)}`;

  return <Text14 themeColor={ThemeColorType.gray}>{dateString}</Text14>;
};

export default DateRowReadOnly;
